import dayjs from 'dayjs'

export const formatDayjsDateTime = dateStr => {
  if (dateStr) {
    return dayjs(dateStr).format('MM/DD/YYYY HH:mm:ss')
  } else {
    return null
  }
}
export const formatDayjsDate = date => {
  return dayjs(date).format('MM/DD/YYYY')
}
export const formatDateTime = date => {
  if (date) {
    return dayjs(date).format('MM/DD/YYYY hh:mm A')
  } else {
    return null
  }
}
export const formatTimeAndSeconds = date => {
  if (date) {
    return dayjs(date).format('hh:mm:ss A') // e.g., "03:58:20 PM"
  } else {
    return null
  }
}
export const formatSecondsAsMinutesAndSeconds = ttl => {
  if (ttl == null) return null
  const minutes = Math.floor(ttl / 60)
  const seconds = ttl % 60
  return `${minutes} minute${minutes !== 1 ? 's' : ''} ${seconds} second${seconds !== 1 ? 's' : ''}`
}
export const formatISODate = date => {
  if (date) {
    return dayjs(date).toISOString()
  } else {
    return null
  }
}
export const formatDayJsTime = dateStr => {
  if (dateStr) {
    return dayjs(dateStr).format('hh:mm A')
  } else {
    return null
  }
}
export const formatDateString = date => {
  if (!date) return ''
  return dayjs.isDayjs(date) ? date.format('MM/DD/YYYY') : dayjs(date).format('MM/DD/YYYY')
}
export const formatDayjsModifiedTime = dateStr => {
  if (dateStr) {
    return dayjs(dateStr).format('MM/DD/YYYY hh:mm A')
  } else {
    return null
  }
}
export const formatMonthYear = value => {
  const parsed = dayjs(value, 'YYYY-MM', true)
  return parsed.isValid() ? parsed.format('MMMM YYYY') : value
}
export const isActiveThisMonth = (start, end) => {
  const today = new Date()
  const todayUTC = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()))
  try {
    const startDate = new Date(start)
    const endDate = new Date(end)
    return startDate <= todayUTC && endDate >= todayUTC
  } catch (e) {
    console.warn(`❌ Invalid date in product: start=${start}, end=${end}`, e)
    return false
  }
}
export const isActiveProduct = (start, end) => {
  const today = new Date()
  const todayUTC = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()))

  try {
    const _startDate = new Date(start)
    const endDate = new Date(end)

    // Product is currently active or will be in the future
    return endDate >= todayUTC
  } catch (e) {
    console.warn(`❌ Invalid date in product: start=${start}, end=${end}`, e)
    return false
  }
}
